import { IPaymentOfferModel } from "@nf/common";
import cx from "classnames";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import ChooseOfferButton from "./CardComponents/ChooseOfferButton";

import CheckMark from "resources/icons/payments/checkmark-round.svg";

const OfferPrice = dynamic(() => import("./CardComponents/OfferPrice"));

export interface SimpleOfferCardProps {
  offer: IPaymentOfferModel;
  active?: boolean;
  savings?: string;
  displayMode?: "choose" | "change";
  handleSelect?: (offerId: number, offerHandle: string) => void;
}

export const SimpleOfferCard = ({
  offer,
  active,
  savings,
  displayMode,
  handleSelect,
}: SimpleOfferCardProps) => {
  const { t } = useTranslation("translations");

  return (
    <div
      className={cx("OfferContainer", "clickable", active && "active")}
      onClick={() => handleSelect?.(offer.Id, offer.Handle)}
    >
      {savings && <div className={"annualSave"}>{savings}</div>}

      <OfferPrice
        price={offer.Price}
        period={offer.Period}
        savings={offer.SavingsPrice}
      />

      {displayMode === "change" && active ? (
        <div className={"VoucherSuccess"}>
          <span>
            <CheckMark /> {t("web_subscription_change_current_plan")}
          </span>
        </div>
      ) : (
        handleSelect && <ChooseOfferButton offer={offer} />
      )}
    </div>
  );
};

export default SimpleOfferCard;
